import { AnySectionItem, CategoryId, CompSkin, CompStyleId, CompType } from '@wix/add-panel-common';
import { always, assocPath, evolve, ifElse, lensPath, over, pipe } from 'ramda';
import { useMemo } from 'react';
import { useCurrentCategory } from '../../../../../CurrentCategoryProvider';
import { useUtils } from '../../../../../UtilsProvider';

const updateItemSkin = <Item>(item: Item) =>
  pipe<Item, Item, Item>(
    assocPath(['structure', 'skin'], CompSkin.WRichTextThemeSkin),
    over(
      lensPath(['structure', 'style']),
      ifElse(
        (style) => typeof style === 'string',
        always(CompStyleId.TxtTheme),
        evolve({
          skin: always(CompSkin.WRichTextThemeSkin),
          id: always(CompStyleId.TxtTheme),
        }),
      ),
    ),
  )(item);

export const useTextComponentsSkin = <Item extends AnySectionItem>(item: Item): Item => {
  const { shouldUseTextThemes } = useUtils();
  const { id: categoryId } = useCurrentCategory();

  const isTextThemesExperiment = shouldUseTextThemes();
  const isTextCategory = categoryId === CategoryId.Text;
  const isTextComponent = item.structure?.componentType === CompType.WRichText;

  const shouldUpdateItemSkin = isTextThemesExperiment && isTextCategory && isTextComponent;

  return useMemo<Item>(() => (shouldUpdateItemSkin ? updateItemSkin(item) : item), [item, shouldUpdateItemSkin]);
};
